/**
 * Helpers pour formater / extraire une estimation chiffrée depuis un lead.
 * Utilisé côté client (message lead) et serveur (e-mails de confirmation).
 */

export function formatEuroRange(min: number, max: number): string {
  const fmt = (n: number) => Math.round(n).toLocaleString('fr-FR', { maximumFractionDigits: 0 });
  if (min === max) return `${fmt(min)} €`;
  return `${fmt(min)}–${fmt(max)} €`;
}

/** Préfixe stable dans `lead.message` pour les funnels qui n'envoient pas de JSON. */
export function buildEstimateLine(min: number, max: number): string {
  return `Estimation: ${formatEuroRange(min, max)}`;
}

/**
 * Extrait un libellé d'estimation depuis `lead.message` :
 * 1. JSON diagnostic `{ primeMin, primeMax }`
 * 2. Ligne `Estimation: …`
 */
export function extractEstimateAmount(message: string | null | undefined): string | null {
  if (!message || !message.trim()) return null;

  const trimmed = message.trim();
  if (trimmed.startsWith('{')) {
    try {
      const parsed = JSON.parse(trimmed) as {
        primeMin?: unknown;
        primeMax?: unknown;
        totalMin?: unknown;
        totalMax?: unknown;
      };
      const min =
        typeof parsed.primeMin === 'number'
          ? parsed.primeMin
          : typeof parsed.totalMin === 'number'
            ? parsed.totalMin
            : null;
      const max =
        typeof parsed.primeMax === 'number'
          ? parsed.primeMax
          : typeof parsed.totalMax === 'number'
            ? parsed.totalMax
            : null;
      if (min != null && max != null && Number.isFinite(min) && Number.isFinite(max)) {
        return formatEuroRange(min, max);
      }
    } catch {
      /* not JSON */
    }
  }

  const line = trimmed.match(/^Estimation:\s*(.+)$/im);
  if (line?.[1]) return line[1].trim();

  return null;
}
